import Repository from "../Repository"
const get_variation = "getVariations"
const add_variation = "addVariations"
const edit_variation = "updateVariations"

export default {
    getVariations(payload) {
        return Repository.post(transformRoute(get_variation), payload);
    },
    addVariations(payload) {
        return Repository.post(transformRoute(add_variation), payload);
    },
    editVariations(payload) {
        return Repository.post(transformRoute(edit_variation), payload);
    },

}

const transformRoute = route => {
  return `/variations/${route}`;
};